import { Cards, Container, Content, Card } from "./styles";

import Image1 from "../../images/image2.png";
import Image2 from "../../images/image3.png";

const HowCanWeHelp = () => {
  return (
    <Container>
      <Content>
        <h1>Como podemos te ajudar</h1>

        <Cards>
          <Card>
            <img src={Image1} alt="imagem" />
            <div>
              <h3>Acidentes de Trânsito</h3>
              <ul>
                <li>Defesa para empresas e motoristas.</li>
                <li>Estratégia para minimizar custos jurídicos.</li>
              </ul>
            </div>
          </Card>
          <Card>
            <img src={Image2} alt="imagem" />
            <div>
              <h3>Direito do Consumidor</h3>
              <ul>
                <li>Indenizações, cobranças e contratos.</li>
                <li>
                  Resolução de problemas para sua empresa nas relações com seu
                  consumidor, sem burocracia.
                </li>
              </ul>
            </div>
          </Card>
        </Cards>
      </Content>
    </Container>
  );
};

export default HowCanWeHelp;
